import o from"styled-components";var e=o("div").withConfig({componentId:"sc-w3sqmf-0"})(["display:flex;flex-direction:column;"]);export{e as Section};
